import Character from "@lss/common/src/shell/Character";


interface TomINT {
}

const tomProperties: TomINT = {
}

export const tom = new Character<TomINT>("Tom", tomProperties, "#6391FFFF");
